var _rect, _rect2, _rect3, _rect4, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 28",
    role: "img",
    "aria-label": "Slack",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#E01E5A",
    x: 0,
    y: 4,
    width: 8,
    height: 8,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#36C5F0",
    x: 12,
    y: 0,
    width: 8,
    height: 8,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#2EB67D",
    x: 0,
    y: 16,
    width: 8,
    height: 8,
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ECB22E",
    x: 12,
    y: 12,
    width: 8,
    height: 8,
    rx: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 19,
    fill: "#4A154B",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "Slack")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.3c3be8fa429ed7a10cbfdb45ca373b50.svg";
export { ForwardRef as ReactComponent };